import crudTemplate from "../../../templates/crudTemplate";
import TariffTimeFrames from "../../../utils/services/project/accounting/tariffPlanTimeframesService";
import i18n from "../../../../plugins/i18n";
let crud = crudTemplate(TariffTimeFrames);
function prepareItem(i) {
  const days = [
    { name: "monday", label: i18n.t("weekdays.Mon"), value: i.monday },
    { name: "tuesday", label: i18n.t("weekdays.Tue"), value: i.tuesday },
    { name: "wednesday", label: i18n.t("weekdays.Wed"), value: i.wednesday },
    { name: "thursday", label: i18n.t("weekdays.Thu"), value: i.thursday },
    { name: "friday", label: i18n.t("weekdays.Fri"), value: i.friday },
    { name: "saturday", label: i18n.t("weekdays.Sat"), value: i.saturday },
    { name: "sunday", label: i18n.t("weekdays.Sun"), value: i.sunday }
  ];

  i.weekdays_value = days
    .filter(day => day.value === true)
    .map(day => {
      return day.name;
    });
  i.weekdays = days
    .reduce((acc, day) => {
      if (i[day.name]) {
        acc.push(day.label);
      }
      return acc;
    }, [])
    .join(", ");

  return i;
}

const state = {
  ...crud.state
};

const getters = {
  ...crud.getters,
  getList(state) {
    let list = crud.getters.getList(state);
    return list.map(prepareItem);
  },
  getItem() {
    let item = crud.getters.getItem(state);
    item.project_id = item._project && item._project.id;
    return item.map(prepareItem);
  }
};

const actions = {
  ...crud.actions,
  create(_, { item, errorHandler = () => {}, onSuccess = () => {} }) {
    let weekdays = [
      { key: "monday", value: false },
      { key: "tuesday", value: false },
      { key: "wednesday", value: false },
      { key: "thursday", value: false },
      { key: "friday", value: false },
      { key: "saturday", value: false },
      { key: "sunday", value: false }
    ];
    item.weekdays_value.forEach(name => {
      const day = weekdays.find(d => d.key === name);
      if (day) {
        day.value = true;
      }
    });
    item = {
      _tariff_plan: { id: item.tariffPlan },
      project_id: item.project_id,
      name: item.name,
      start: item.start,
      end: item.end,
      monday: weekdays?.[0]?.value || false,
      tuesday: weekdays?.[1]?.value || false,
      wednesday: weekdays?.[2]?.value || false,
      thursday: weekdays?.[3]?.value || false,
      friday: weekdays?.[4]?.value || false,
      saturday: weekdays?.[5]?.value || false,
      sunday: weekdays?.[6]?.value || false
    };
    return crud.actions.create(_, {
      item: { ...item },
      errorHandler,
      onSuccess
    });
  },
  update(_, { item, errorHandler = () => {}, onSuccess = () => {} }) {
    let weekdays = [
      { key: "monday", value: false },
      { key: "tuesday", value: false },
      { key: "wednesday", value: false },
      { key: "thursday", value: false },
      { key: "friday", value: false },
      { key: "saturday", value: false },
      { key: "sunday", value: false }
    ];
    item.weekdays_value.forEach(name => {
      const day = weekdays.find(d => d.key === name);
      if (day) {
        day.value = true;
      }
    });
    item = {
      id: item.id,
      _tariff_plan: { id: item.tariffPlan },
      project_id: item.project_id,
      name: item.name,
      start: item.start,
      end: item.end,
      monday: weekdays?.[0]?.value || false,
      tuesday: weekdays?.[1]?.value || false,
      wednesday: weekdays?.[2]?.value || false,
      thursday: weekdays?.[3]?.value || false,
      friday: weekdays?.[4]?.value || false,
      saturday: weekdays?.[5]?.value || false,
      sunday: weekdays?.[6]?.value || false
    };
    return crud.actions.update(_, {
      item: { ...item },
      errorHandler,
      onSuccess
    });
  }
};

const mutations = {
  ...crud.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
